import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { trigger, state, animate, transition, style, keyframes } from '@angular/animations';
import { BaseComponent } from '../base.component';
import { SharedService } from '../shared.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../loader.service';
import { ValidationService } from '../../technician/technician-jobs/technician-common-validation';
import { TechnicianJobService } from '../../technician/technician-jobs/technician-jobs.service';
import {
    EquipmentEntity, WoJobTaskDetails, JobPrintPre,
    JobDetailMaster, JobAppointMent, SpecialService, PrintPreview, Logo, Company, PricingModelTable,
    PricingModel, ChecklistModel, PrintcheckListModel, PrintCheckListHeader,
    PCheckList, DynamicCheckListDetails, AttachmentsModel, AttachmentsListModel, attachmentchecklist,
    ThumbList, RefEmailPrintJobSetting, JobPrintPreWhole, CustomerDetails, EquipmentDetails,
    PartRequestDetails, specialInstructionDetails, serviceNotesDetails,
    WoSLAHistoryDetails, JobRMAPartDetailsEntity, PCheckListDetails, thumbListFilter,
    attachmentsqueueEntity,
    PricingDetailsEntity,
    JobShippingDetailsEntity,
    AttachmentDetails,
    PCheckListAttachmentDetails,
    SigNature,
    technicianRemarksDetails,
    TravelConveyance,
    TravelConveyanceEntity
} from '../../technician/technician-jobs/technician-jobs.models';
import { PartRequestEntity, WoSLAHistory, TaxGroup } from '../../work-order/work-order-models';
import { WoService } from 'app/layout/work-order/work-order.service';
declare let jsPDF;
@Component({
    selector: 'job-print-preview-popup-pro',
    templateUrl: 'print-preview-pro.html',
    animations: [
        trigger('isVisibleChanged', [
            transition('void => *', [
                animate(600, keyframes([
                    style({ opacity: 0, transform: 'translateY(-200px)', offset: 0 }),
                    style({ opacity: 1, transform: 'translateY(25px)', offset: .75 }),
                    style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
                ]))
            ])
        ])
    ],
    styles: [`
    .m-dialog { width: 80%;margin: 30px auto;} 
    .hideScreen{display:none;} 
    #PrintPanel table > thead > tr > th, table > tbody > tr > th, table > tfoot > tr > th, table > thead > tr > td, table > tbody > tr > td, table > tfoot > tr > td {border-top: 0; } 
    #PrintPanel { font: 12px calibri;}  
    .s_formLabel {border: 1px solid #ccc;}
    .s_formLabel > tbody > tr{       
        border-bottom: 1px solid #ccc;
        color: #505050;      
    }
    .s_formLabel > tbody > tr > td{
        padding: 5px;
    }
    #printContainer tr th{
        background: #D9D9D9 !important;
        padding: 8px 0 !important;
        color: #4e4e4e !important;
        text-align: center;
       }
       .Tbl-Border{
        border: 1px solid #bfbfbf;
    }
    
    .main-heading h1{font-size:15px !important;color:#4e4e4e!important;}
    .SignatureTbl
    {
     border-top: 1px solid #ccc;
     padding: 5px 20px 0 20px;
     color: #4e4e4e;
     font-size: 15px;
    }
    .Tbl-Span
   {
    font-size: 12px;
   }
   .checked {
    color: #ffdb10 !important;
    border-color:#ffdb10 !important;
  }
  .unchecked{
    color: #D3D3DF !important;
    border-color:#ffdb10 !important;
  }
  .custom-th-le{
    background: #eeeeee !important;
    padding: 2px 10px !important;
    text-align: right;
    
}
.job-dtl tbody>tr>td {
    padding: 2px;
}
.custom-th-ri{
    //padding: 8px 10px !important;
    text-align: right;
    
}
.address-head{
    background: #eeeeee !important;
    padding: 3px 5px !important;
text-align: left;

}
    `],
    encapsulation: ViewEncapsulation.None
})

export class JobPrintPreviewProComponent extends BaseComponent implements OnInit {

    @Output() done = new EventEmitter();
    @Input() woJobId: number;
    @Input() CustomerId: number;
    @Input() TechId: number;
    @Input() WorkOrderId: number;
    @Input() woJobIdList: number[] = [];
    companyId: number;
    userId: number;
    equipmentEntity: EquipmentEntity[] = [];
    jobId: number;
    jobDetailMaster: JobDetailMaster;
    jobAppointMent: JobAppointMent;
    logo: Logo = new Logo();
    customerAndTechDetails: PrintPreview;
    JobPrintpreview: JobPrintPre[];
    JobPrintpreviewWhole: JobPrintPre[];
    jobPrintPreWhole: JobPrintPreWhole;
    jobPrintPreWholenew: any[] = [];
    customerAndTechDetailsList: PrintPreview[];
    jobDetailListTab: WoJobTaskDetails[] = [];
    specialInstruction: SpecialService[] = [];
    serviceNotes: SpecialService[] = [];
    technicianRemarksList: SpecialService[] = [];
    serviceNotesReason: any;
    specialInsstructionReason: any;
    displayName: string;
    company: Company = new Company();
    logoPrintout: Logo = new Logo();
    logoPrintoutHeader: Logo = new Logo();
    logoPrintoutFooter: Logo = new Logo();
    WoJobNo: string = "";
    partRequestEntity: PartRequestEntity[] = [];
    hoursStr: string;
    minStr: string;
    daysStr: string;
    woSLAhistory: WoSLAHistory[];
    woslahistory: WoSLAHistory;
    isVisible: boolean = false;
    signature1: boolean;
    signature2: boolean;
    signature3: boolean;
    Signature1: string;
    Signature2: string;
    Signature3: string;
    isEnableTax: boolean = false;
    pricingModelTable: PricingModel[] = [];
    //pricingModel: PricingModel[] = [];
    jobTotal: any = 0;
    jobGrandTotal: any;
    currency: any;
    refEmailPrintJobSetting: RefEmailPrintJobSetting[];
    IsProjectEnabled: boolean = false;
    CustomerSignature: number;
    isRemarks: number;
    isFeedback: number;
    isSignature1: number;
    isSignature2: number;
    isSignature3: number;
    isBillingAddress: number;
    sigNature: SigNature[] = [];
    sigNatureModel: SigNature = new SigNature;
    customerSignatureimg: string;
    actualWorkedTime: string;
    DistanceKey: string;
    TravelDuration: string;
    PPrintNotes: string;
    constructor(protected sharedService: SharedService, protected translate: TranslateService, protected _woService: WoService,
        private _technicianJobService: TechnicianJobService, private datePipe: DatePipe, private loaderService: LoaderService) {
        super(sharedService, translate);

        this.companyId = super.globalInfo().CompanyId;
        this.userId = super.globalInfo().LoginId;
        this.customerAndTechDetails = new PrintPreview();
        this.customerAndTechDetailsList = [];
        this.woslahistory = new WoSLAHistory();
        this.currency = super.globalInfo().Currency;
    }

    ngOnInit() {
        this.IsProjectEnabled = super.globalInfo().ProjectEnabled == 1 ? true : false;
        this.signature1 = this.translate.instant('SIGNATURE1') == "" ? false : true;
        this.signature2 = this.translate.instant('SIGNATURE2') == "" ? false : true;
        this.signature3 = this.translate.instant('SIGNATURE3') == "" ? false : true;
        let jobIds = this.woJobIdList;
        if (this.woJobIdList.length == 0) {
            this.woJobIdList.push(this.woJobId);
            jobIds = this.woJobIdList;
        }


        this._technicianJobService.GetEmailPrintJobSetting(this.companyId)
            .subscribe(s => {
                this.refEmailPrintJobSetting = s.filter(f => f.SettingTypeId == 1);
                this.Signature1 = this.refEmailPrintJobSetting.filter(f => f.SettingId == 15)[0].Caption;
                this.Signature2 = this.refEmailPrintJobSetting.filter(f => f.SettingId == 16)[0].Caption;
                this.Signature3 = this.refEmailPrintJobSetting.filter(f => f.SettingId == 17)[0].Caption;
                this.PPrintNotes = this.refEmailPrintJobSetting.filter(f => f.SettingId == 21)[0].Caption;
                this.CustomerSignature = this.refEmailPrintJobSetting.filter(f => f.SettingId == 12)[0].IsEnabled;
                this.isRemarks = this.refEmailPrintJobSetting.filter(f => f.SettingId == 14)[0].IsEnabled;
                this.isFeedback = this.refEmailPrintJobSetting.filter(f => f.SettingId == 13)[0].IsEnabled;
                this.isSignature1 = this.refEmailPrintJobSetting.filter(f => f.SettingId == 15)[0].IsEnabled;
                this.isSignature2 = this.refEmailPrintJobSetting.filter(f => f.SettingId == 16)[0].IsEnabled;
                this.isSignature3 = this.refEmailPrintJobSetting.filter(f => f.SettingId == 17)[0].IsEnabled;
                this.isBillingAddress = this.refEmailPrintJobSetting.filter(f => f.SettingId == 19)[0].IsEnabled;
            });
        this.getJobDetailsPrintPre(jobIds);

        this.printlogo(jobIds[0]);
        this.GetByCustomerFeedBack(jobIds[0]);
        this._technicianJobService.getJobSignature(this.companyId, jobIds[0])
            .subscribe(s => {
                debugger;
                this.sigNature = s;
                if (this.sigNature.length > 0) {
                    this.sigNatureModel = this.sigNature.find(f => f.CompanyId == this.companyId);
                    this.customerSignatureimg = this.sigNatureModel.CustomerSignature;
                }
            });
    }
    checklistAll: ChecklistModel[] = [];
    selectedCheckLst: PrintcheckListModel[] = [];
    chkListId: number[] = [];
    chkListMasterId: number[] = [];
    chkListHeader: PrintCheckListHeader;
    PCheckList: PCheckList[];
    attachmentdetailsArray: AttachmentDetails[];
    attachmentdetails: AttachmentDetails;
    //checklistattachment :attachmentchecklist[]=[];

    getCheckList(jobid: number) {
        // this.checklistAll = [];
        this._technicianJobService.getCheckListAll(this.companyId, jobid)
            .subscribe(s => {

                if (s.length > 0) {
                    this.checklistAll = s;
                    this.chkListId = [];
                    this.checklistAll.forEach(f => {
                        this.selectedCheckLst.push(
                            {
                                ChklistMastId: f.ChklistMastId,
                                CompanyId: f.CompanyId,
                                WoJobChklistId: f.WoJobChklistId,
                                WoJobId: f.WoJobId,
                                ChklistName: f.ChklistName,
                                Description: f.Description,
                                LoginId: this.globalInfo().LoginId

                            })
                        this.chkListId.push(f.WoJobChklistId);
                        this.chkListMasterId.push(f.ChklistMastId);
                    });
                    if (this.selectedCheckLst.length > 0) {

                        let chklid = this.chkListId;
                        let id = this.chkListMasterId;
                        this._technicianJobService.getchklistJobPrintAttachementsDetails(super.globalInfo().CompanyId, chklid).subscribe(res => {
                            this.attachmentsqueue = res;
                            this.attachmentsqueue.forEach(f => {
                                f.CapturedDate = this.datetimeFormat(f.CapturedDate);
                            });
                            this.JobPrintpreview.map(s => {
                                s.attachmentsqueue = this.attachmentsqueue;
                            })
                            // this._technicianJobService.getCheckListattachmentPrintDetails(super.globalInfo().CompanyId, jobid, id)
                            //     .subscribe(s => {

                            //this._loaderservice.hide();
                            // this.attachementsFilter = s.filter(x => x.WoJobId == jobid && x.AttachmentCategoryId == 67).map(m => {
                            //     if (m.CapturedDate != null && m.CapturedDate != "") {
                            //         m.CapturedDate = this.datePipe.transform(m.CapturedDate, 'shortDate') + " " + this.datePipe.transform(m.CapturedDate, 'shortTime')
                            //     }
                            //     return m;
                            // });
                            this._technicianJobService.getcheckListPrintData(this.selectedCheckLst).subscribe(
                                s => {
                                    debugger;
                                    //this.loaderservice.hide();                        
                                    if (s.PCheckList != undefined && s.PCheckList.length > 0) {
                                        this.chkListHeader = s.CustomerInfo;
                                        this.PCheckList = s.PCheckList;
                                        if (s.CustomerInfo) {
                                            this.chkListHeader = s.CustomerInfo;
                                            this.PCheckList = s.PCheckList;

                                            //var checklistdetailId=[];
                                            this.PCheckList.map(
                                                p => {
                                                    var checklistattachment = [];
                                                    //p.QuestionAnswer.forEach(f=>{checklistdetailId.push(f.WoJobChecklistDetailId)});
                                                    p.QuestionAnswer.forEach(qa => {
                                                        var attachmentarray = this.attachmentsqueue.filter(f => f.WoJobChklistDtlId == qa.WoJobChecklistDetailId);
                                                        if (attachmentarray.length > 0) {
                                                            attachmentarray.forEach(aa => {
                                                                checklistattachment.push(aa);
                                                            });
                                                        }
                                                    });
                                                    p.attachementsFilter = checklistattachment;
                                                    // p.QuestionAnswer.forEach(qa => {

                                                    //     this.attachmentdetailsArray = [];
                                                    //     var attachmentarray = this.attachementsFilter.filter(f => f.WoJobChklistDtlId == qa.WoJobChecklistDetailId);
                                                    //     if (attachmentarray.length > 0) {
                                                    //         attachmentarray.forEach(aa => {
                                                    //             this.attachmentdetails = new AttachmentDetails;
                                                    //             this.attachmentdetails.Attachment = aa.Attachment;
                                                    //             this.attachmentdetails.AttachmentCaptured = aa.CapturedDate;
                                                    //             this.attachmentdetails.AttachmentDescription = aa.Description;
                                                    //             this.attachmentdetails.AttachmentType = aa.Type;
                                                    //             this.attachmentdetails.AttachmentCategory = aa.Category;
                                                    //             this.attachmentdetails.ChklistName = aa.ChklistName;
                                                    //             this.attachmentdetails.AttachmentCategoryId = aa.AttachmentCategoryId
                                                    //             this.attachmentdetailsArray.push(this.attachmentdetails);
                                                    //         });
                                                    //         qa.attachmentDetails = this.attachmentdetailsArray;
                                                    //     }
                                                    // });

                                                    let k = 0;
                                                    let q = p.QuestionAnswer;
                                                    p.QuestionAnswer.filter(f => !f.IsSubFormQuestion).map(m => {
                                                        m.show = true;
                                                        m.IsSubFormQuestion = false;
                                                        k++;
                                                        if (m.FieldSourceId == 3) {
                                                            if (m.ParentQuestionId) {//If have Parant Question - Display Question & Answer
                                                                let gparantQuestion = q.find(f => f.ChklistDtlId == m.ParentQuestionId);
                                                                let gparantQuestionAnswer: any;
                                                                if (gparantQuestion) {
                                                                    gparantQuestionAnswer = gparantQuestion.dropdownvalues.find(f => f.ChklistDdDtlId == m.ParentQuestionAnswerId);
                                                                    gparantQuestionAnswer = gparantQuestionAnswer ? gparantQuestionAnswer.ValueList : '';
                                                                }
                                                                m.SubFormParantQuestion = gparantQuestion ? gparantQuestion.Question + " : " + gparantQuestionAnswer : '';
                                                                m.show = false;
                                                            }
                                                            m.SubFormList.map(sm => {
                                                                if (sm.ParentQuestionId || m.ParentQuestionId)
                                                                    sm.show = false;
                                                                else
                                                                    sm.show = true;
                                                                sm.IsSubFormQuestion = true;
                                                                q.splice(k, 0, sm);
                                                                k++;
                                                            });
                                                        }
                                                        return m;
                                                    });

                                                    q.forEach(nq => {
                                                        if (nq.FieldTypeId == 28) {
                                                            //Dropdown Data if Inactive Master Level, take Inactive Also
                                                            if (nq.WoChklistDdId) {
                                                                let v = nq.dropdownvalues.find(f => f.ChklistDdDtlId == nq.WoChklistDdId);
                                                                if (v) nq.ValueList = v.ValueList;
                                                            }
                                                            this.showChildddl(nq.WoChklistDdId, nq.ChklistDtlId, nq.SubFormParentId, nq.IsSubFormQuestion, q);
                                                        }
                                                        else if (nq.FieldTypeId == 328) {
                                                            let cldata: any[] = [];
                                                            nq.dropdownvalues.forEach(v => {
                                                                let cked = 0;
                                                                if (nq.MultiCheckBoxControl) {
                                                                    let ans = nq.MultiCheckBoxControl.find(f => f == v.ChklistDdDtlId);
                                                                    cked = (ans ? 1 : 0);
                                                                }
                                                                cldata.push({ label: v.ValueList, value: v.ChklistDdDtlId, checked: cked });
                                                            });
                                                            nq.dropdownvalues = cldata;
                                                            this.showChildchkboxlist(nq.MultiCheckBoxControl, nq.ChklistDtlId, nq.SubFormParentId, nq.IsSubFormQuestion, q);
                                                        }
                                                        else if (nq.FieldTypeId == 350) {
                                                            let a = !isNaN(Date.parse(nq.DtValue));
                                                            nq.DtValue = (a ? (new Date(nq.DtValue)) : nq.DtValue);
                                                        }
                                                    });
                                                }
                                            );
                                            this.JobPrintpreview.map(s => {
                                                s.PCheckList = this.PCheckList;
                                            })

                                            this.getPricingDetails(jobid);
                                        }
                                    }
                                },
                                e => {
                                    //this.loaderservice.hide();
                                });
                            // }, e => { 
                            //     //this._loaderservice.hide(); 
                            // });



                        })
                    }
                } else {
                    this.getPricingDetails(jobid);
                }
            });
    }
    showChildddl(obj: number, ChklistDtlId: number, SubFormParentId: number, IsSubFormQuestion: boolean, DFList: DynamicCheckListDetails[]) {
        //Main Form
        if (IsSubFormQuestion == false) {
            // Main Question Hidden
            let mainQuestion = DFList.filter(f => f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == false)
            mainQuestion.forEach(mQ => {
                mQ.show = false;
                // Main Question Sub Form Questions Hidden
                if (mQ.FieldSourceId == 3) {
                    let subformList = DFList.filter(f => f.IsSubFormQuestion == true && f.SubFormParentId == mQ.WoJobChecklistDetailId);
                    subformList.forEach(s => {
                        s.show = false;
                    });
                }
                // parant - child question 
                this.showChildddl(0, mQ.ChklistDtlId, mQ.SubFormParentId, mQ.IsSubFormQuestion, DFList);

            });

            // Activate Child Questions - Main
            let dActive = DFList.filter(f => f.ParentQuestionAnswerId == obj && f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == false);
            dActive.forEach(da => {
                da.show = true;
                if (da.FieldSourceId == 3) {
                    let subformList = DFList.filter(f => f.IsSubFormQuestion == true
                        && f.SubFormParentId == da.WoJobChecklistDetailId && (f.ParentQuestionId == 0 || f.ParentQuestionId == null));
                    subformList.forEach(s => {
                        s.show = true;
                    });
                }
            });

        }
        //Sub Form
        else {
            let SubFormQuestion = DFList.filter(f => f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == true && f.SubFormParentId == SubFormParentId);
            SubFormQuestion.forEach(sf => {
                sf.show = false;
                this.showChildddl(0, sf.ChklistDtlId, sf.SubFormParentId, sf.IsSubFormQuestion, DFList);
            });

            // Activate Child Questions - Sub
            let sActive = DFList.filter(f => f.ParentQuestionAnswerId == obj && f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == true && f.SubFormParentId == SubFormParentId);
            sActive.forEach(sa => {
                sa.show = true;
            });
        }
    }
    showChildchkboxlist(obj: any, ChklistDtlId: number, SubFormParentId: number, IsSubFormQuestion: boolean, DFList: DynamicCheckListDetails[]) {
        //Main Form
        if (IsSubFormQuestion == false) {
            // Main Question Hidden
            let mainQuestion = DFList.filter(f => f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == false)
            mainQuestion.forEach(mQ => {
                mQ.show = false;

                // Main Question Sub Form Questions Hidden
                if (mQ.FieldSourceId == 3) {
                    let subformList = DFList.filter(f => f.IsSubFormQuestion == true && f.SubFormParentId == mQ.WoJobChecklistDetailId);
                    subformList.forEach(s => {
                        s.show = false;
                    });
                }
                // parant - child question 
                this.showChildchkboxlist(0, mQ.ChklistDtlId, mQ.SubFormParentId, mQ.IsSubFormQuestion, DFList);

            });

            if (obj) {
                let data = [];
                data = (obj.value ? obj.value : obj);
                data.forEach(el => {
                    // Activate Child Questions - Main
                    let dActive = DFList.filter(f => f.ParentQuestionAnswerId == el && f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == false);
                    dActive.forEach(da => {
                        da.show = true;
                        if (da.FieldSourceId == 3) {
                            let subformList = DFList.filter(f => f.IsSubFormQuestion == true
                                && f.SubFormParentId == da.WoJobChecklistDetailId && (f.ParentQuestionId == 0 || f.ParentQuestionId == null));
                            subformList.forEach(s => {
                                s.show = true;
                            });
                        }
                    });
                });
            }
        }
        //Sub Form
        else {
            let SubFormQuestion = DFList.filter(f => f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == true && f.SubFormParentId == SubFormParentId);
            SubFormQuestion.forEach(sf => {
                sf.show = false;
                this.showChildchkboxlist(0, sf.ChklistDtlId, sf.SubFormParentId, sf.IsSubFormQuestion, DFList);
            });

            if (obj) {
                let data = [];
                data = (obj.value ? obj.value : obj);
                data.forEach(el => {
                    // Activate Child Questions - Sub
                    let sActive = DFList.filter(f => f.ParentQuestionAnswerId == el && f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == true && f.SubFormParentId == SubFormParentId);
                    sActive.forEach(sa => {
                        sa.show = true;
                    });
                });
            }
        }
    }
    getPricingDetails(jobid: any) {

        this.jobTotal = 0;
        this._technicianJobService.getPricingDetails(super.globalInfo().CompanyId, jobid)
            .subscribe(s => {
                this.isEnableTax = this.sharedService.isEnableTax;
                //this.pricingModel = s;
                this.pricingModelTable = s;

                // this.pricingModelTable = r;
                this.pricingModelTable.map(m => {
                    m.Qty = (m.PricingUnitId == 418 && m.PriceTypeId == 83) ? this.hourCalculation(m.DaysPerTask, m.HoursPerTask, m.MinutesPerTask).toString() : m.Qty;
                });

                this.pricingTableFilling(this.pricingModelTable, jobid);

            });
    }

    pricingTableFilling(pricing: PricingModelTable[], jobid: number) {
        this.jobGrandTotal = 0;
        this.pricingModelTable = pricing.map(m => {
            m.PricingCount = this.pricingModelTable.length;
            if (m.IsBOQRequest == 1 && m.ApprovalStatusId == 3)
                m.TotalAmount = ((m.ApprovedQty == null ? 0 : m.ApprovedQty) * (m.UnitPrice == null ? 0 : m.UnitPrice));
            else
                m.TotalAmount = ((m.Qty == null ? 0 : m.Qty) * (m.UnitPrice == null ? 0 : m.UnitPrice));

            let discount = (m.Discount == 0 || m.Discount == null ? 0 : m.Discount);
            let totamount = (m.TotalAmount == 0 || m.TotalAmount == null ? 0 : m.TotalAmount);
            /**Flat calculations */
            if (m.DiscountTypeId == 80) {
                m.NetTotalFormat = ((totamount - discount) == 0 ? '0' : (totamount - discount));
                //this.jobTotal += (ValidationService.isEmpty(m.NetTotalFormat) ? 0 : m.NetTotalFormat);
            }
            /**Discount calculations */
            if (m.DiscountTypeId == 81) {
                let nettotal = (totamount - ((totamount * discount) / 100));
                m.NetTotalFormat = nettotal == 0 ? '0' : nettotal;
                //this.jobTotal += (ValidationService.isEmpty(m.NetTotalFormat) ? 0 : m.NetTotalFormat);
            }


            m.TaxFormat = m.Percentage == null ? '0' : (m.NetTotalFormat * m.Percentage / 100);
            m.NetTotalFormat = (ValidationService.isEmpty(m.NetTotalFormat + m.TaxFormat)) ? "0" : (m.NetTotalFormat + m.TaxFormat);
            m.TaxFormat = (m.TaxFormat == null || (ValidationService.isEmpty(m.TaxFormat)) ? "-" : (this.currency + parseFloat(m.TaxFormat).toFixed(2)));
            this.jobTotal += (ValidationService.isEmpty(m.NetTotalFormat) ? 0 : (+m.NetTotalFormat));
            m.NetTotalFormat = ((ValidationService.isEmpty(m.NetTotalFormat)) ? "-" : (this.currency + parseFloat(m.NetTotalFormat).toFixed(2)));

            if (m.IsBOQRequest == 1)
                m.QtyFormat = (m.ApprovalStatusId == 3 ? ((m.ApprovedQty == 0 || m.ApprovedQty == null) ? '-' : m.ApprovedQty) : ((m.Qty == 0 || m.Qty == null) ? '-' : m.Qty));
            else
                m.QtyFormat = ((m.Qty == 0 || m.Qty == null) ? '-' : m.Qty);


            m.UnitPriceFormat = ((m.UnitPrice == 0 || m.UnitPrice == null) ? '-' : this.currency + parseFloat(m.UnitPrice).toFixed(2));
            m.TotalAmountFormat = ((m.TotalAmount == 0) ? '-' : this.currency + parseFloat(m.TotalAmount).toFixed(2));

            m.DiscountFormat = (ValidationService.isEmpty(m.Discount)

                ? '-' : (m.DiscountTypeId == 80 ? (this.currency + m.Discount) : m.Discount + '%'));

            return m;
        });
        this.jobGrandTotal = this.currency + '' + parseFloat(this.jobTotal).toFixed(2);
        this.JobPrintpreview.map(p => {
            p.pricingModelTable = this.pricingModelTable;
        });
        this.getAttachementsDetails(jobid);
    }
    hourCalculation(DurationDay, DurationHour, DurationMin) {
        var totalhr = 0;
        if (DurationDay > 0)
            totalhr = +DurationDay * 8;
        totalhr += +DurationHour;
        if (DurationMin == 15)
            totalhr += 0.25;
        else if (DurationMin == 30)
            totalhr += 0.50;
        else if (DurationMin == 45)
            totalhr += 0.75;
        return totalhr;
    }
    signbyname: string;
    IsCustomerSignatureReq?: number;
    getJobDetailsPrintPre(wojob: number[]) {
        this.loaderService.show();
        this._technicianJobService.getWoJobDetailsPrint(this.companyId, wojob, this.WorkOrderId, this.TechId)
            .subscribe(s => {

                this.JobPrintpreview = s;
                this.loaderService.hide();
                this.JobPrintpreview.forEach(model => {
                    let f = model.CustomerTechDetail;
                    if (f != null) {
                        model.CustomerTechDetail = f;
                        model.CustomerTechDetail.TotalJobDuration = ValidationService.fullDayhourFormat(f.Days, f.Hours, f.Minutes);
                        model.CustomerTechDetail.TechDisplayName = f.TechDisplayName;
                        model.CustomerTechDetail.ServiceAddress = f.AddressLine1;

                        this.signbyname = f.signbyname;
                        this.IsCustomerSignatureReq = f.IsCustomerSignatureReq;

                        this.WoJobNo = f.WoJobId + "(" + f.WoNumber + ")";
                        model.CustomerTechDetail.WoJobId = model.JobDetail[0].WoJobId;
                        model.CustomerTechDetail.CreatedDate = this.datetimeFormat(f.CreatedDate);
                        model.CustomerTechDetail.ScheduleDate = this.datetimeFormat(f.ScheduleDate);
                        model.CustomerTechDetail.ApptPrefDate = this.datetimeFormat(model.JobDetail[0].ApptPrefDate);
                        this.actualWorkedTime = this.dayhourFormat(f.ActualWorkedDays,f.ActualWorkedHours, f.ActualWorkedMinutes);
                        this.TravelDuration = this.mintohours(f.ActualTravelTime);
                        if(f.ActualTravelDistance != null)
                        if (this.sharedService.distance != 0) {
                            this.translate.get('' + this.sharedService.distance + '').subscribe(s => {
                                this.DistanceKey = f.ActualTravelDistance + ' ' + s;
                            });
                        }
                        else {
                            this.sharedService.distanceemit.subscribe(x => {
                                this.translate.get('' + x.distance + '').subscribe(s => {
                                    this.DistanceKey =   f.ActualTravelDistance + ' ' + s;
                                });
                            });
                        }
                        model.SlaHistoryEntity.map(x => {
                            x.slacount = model.SlaHistoryEntity.length;
                            x.CreatedDate = x.CreatedDate ? this.datePipe.transform(x.CreatedDate, 'short') : null;
                            x.ApptPrefDate = x.ApptPrefDate ? this.datePipe.transform(x.ApptPrefDate, 'short') : null;
                            x.SLAStartTime = x.SLAStartTime ? this.datePipe.transform(x.SLAStartTime, 'short') : null;
                            x.SLAEndTime = x.SLAEndTime ? this.datePipe.transform(x.SLAEndTime, 'short') : null;
                            x.ActualSLAEndTime = x.ActualSLAEndTime ? this.datePipe.transform(x.ActualSLAEndTime, 'short') : null;
                            //x.Durationstr = this.durationCalc(x.Duration);
                            if (x.SLAType == 'Response' && x.RespSLADurationTypeId != 1 && x.RespSLADurationTypeId != 0) {
                                x.Durationstr = x.ResponseSLADurationType;
                            }
                            else if (x.SLAType == 'Resolution' && x.ReslSLADurationTypeId != 1 && x.ReslSLADurationTypeId != 0) {
                                x.Durationstr = x.ResolutionSLADurationType;
                            }
                        });
                        this.GetSpeciInstrAndServiNote(f.TimeZoneId, wojob[0]);
                    }
                    model.JobDetail = model.JobDetail.map(m => {
                        m.HourAndMinutes = ((m.Hours !== null && +m.Hours !== 0) ? m.Hours + ' hr ' : '') + ((m.Minutes !== null && +m.Minutes !== 0) ? m.Minutes + ' mins' : '');
                        m.CompanyId = this.companyId;
                        return m;
                    });
                });

            }, e => { this.loaderService.hide(); });
    }

    durationCalc(val: number) {
        if (val <= 0)
            return "";
        var comStr = "";
        var hrs = 0;
        var days = 0;
        var i = 0, j = 0;
        if (val < 60) {
            comStr = 0 + " " + this.hoursStr + " " + val + " " + this.minStr;
            return comStr;
        }

        for (i = 60; i <= val;) {
            hrs = hrs + 1;
            i = i + 60;
        }
        i = i - 60;
        if (hrs >= 24) {
            for (j = 24; j <= hrs;) {
                days = days + 1;
                j = j + 24;
            }
            j = j - 24;
            comStr = days + " " + this.daysStr + " " + (hrs - j) + " " + this.hoursStr + " " + (val - i) + " " + this.minStr;
        }
        else
            comStr = hrs + " " + this.hoursStr + " " + (val - i) + " " + this.minStr;
        return comStr;
    }

    GetSpeciInstrAndServiNote(TechTimeZoneid: number, wojob: number): void {
        this.specialInstruction = [];
        this.serviceNotes = [];
        this.technicianRemarksList = [];
        this.loaderService.show();//this.woJobId
        this._technicianJobService.GetSpeciInstrAndServiNote(this.companyId, wojob, this.userId, TechTimeZoneid, this.CustomerId, this.WorkOrderId)
            .subscribe(s => {
                this.loaderService.hide();
                this.displayName = s.DisplayName;
                this.specialInstruction = s.GetWojobSplInsDetails;
                this.serviceNotes = s.GetWojobServiceNotesDetails;
                this.technicianRemarksList = s.GetWojobTechnicialRemark;
                this.specialInstruction.map(x=>{x.NoteHtml = x.Note.replace(/(?:\r\n|\r|\n)/g, '<br />')});
                this.serviceNotes.map(x=>{x.NoteHtml = x.Note.replace(/(?:\r\n|\r|\n)/g, '<br />')});
                this.technicianRemarksList.map(x => {
                    x.CreateAndUpdateDate = x.CreatedDate ? this.datetimeFormat(x.CreatedDate) : null;
                    x.NoteHtml = x.Note.replace(/(?:\r\n|\r|\n)/g, '<br />');
                });

                if (this.serviceNotes.length != 0)
                    this.serviceNotesReason = this.serviceNotes[this.serviceNotes.length - 1].Note;
                if (this.specialInstruction.length != 0)
                    this.specialInsstructionReason = this.specialInstruction[this.specialInstruction.length - 1].Note;

                this.JobPrintpreview.map(model => {
                    model.specialInstruction = s.GetWojobSplInsDetails;
                    model.serviceNotes = s.GetWojobServiceNotesDetails;
                    model.technicalRemarks = s.GetWojobTechnicialRemark;
                });
                this.getCheckList(wojob);

            });
    }

    datetimeFormat(dateTimeVal: any): any {
        if (dateTimeVal == "0001-01-01T00:00:00" || dateTimeVal == "" || dateTimeVal == null || dateTimeVal == "1/1/0001 12:00:00 AM")
            return "";
        else
            return this.datePipe.transform(dateTimeVal, 'shortDate') + " " + this.datePipe.transform(dateTimeVal, 'shortTime')
    }

    closePopup() {
        this.done.emit();
    }

    printlogo(wojob: number) {
        this._technicianJobService.getCompany(this.companyId).subscribe(cus => {
            this.company = cus;
            var address = this.company.UnitNo + " " + this.company.AddressLine1 + " " + this.company.AddressLine2 + " " + this.company.CityName + " " + this.company.StateName + " " + this.company.ZipCode + " " + this.company.CountryName;
            this.company.Address = address.replace(/null/g, '');
            if (this.company.PrintoutLogoPath != "" || this.company.PrintoutLogoPath != null || this.company.PrintoutLogoPath != null) {
                this._technicianJobService.GetPrintoutLogo(this.companyId, this.company.PrintoutLogoPath).subscribe(res => {
                    this.logoPrintout = res;
                });
            }

            if (this.company.PrintoutHeaderPath != "" || this.company.PrintoutHeaderPath != null || this.company.PrintoutHeaderPath != null) {
                this._technicianJobService.GetPrintoutHeader(this.companyId, this.company.PrintoutHeaderPath).subscribe(res => {
                    this.logoPrintoutHeader = res;
                });
            }

            if (this.company.PrintOutFooterPath != "" || this.company.PrintOutFooterPath != null || this.company.PrintOutFooterPath != null) {
                this._technicianJobService.GetPrintoutFooter(this.companyId, this.company.PrintOutFooterPath).subscribe(res => {
                    this.logoPrintoutFooter = res;
                });
            }
        });
    }

    Print(): void {

        //let popupWinindow: any;
        let innerContents: any = document.getElementById('printArea').innerHTML;
        let themeClass = document.body.getAttribute("class");
        let popupWindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popupWindow.document.open();
        var headerScript = `
        <link rel="stylesheet" href="/assets/css/zylog-skin.css">
        <link rel="stylesheet" href="/assets/css/zylog-print.css">
        <link rel="icon" type="image/x-icon" href="/assets/img/favicon.png">
        <link rel="stylesheet" href="/assets/css/font-awesome.min.css">
        <link rel="stylesheet" href="/assets/css/zylog-font-icon.css">
        <style>
        @media print {
            .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6,
            .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {
                 float: left;               
            }
            .col-sm-6 {
                width: 50%;
           }
           #printArea{
               -webkit-print-color-adjust: exact; 
           }
           </style>
        <style  type="text/css" media="print"> 
        .m-dialog { width: 80%;margin: 30px auto;} 
    .hideScreen{display:none;} 
    #PrintPanel table > thead > tr > th, table > tbody > tr > th, table > tfoot > tr > th, table > thead > tr > td, table > tbody > tr > td, table > tfoot > tr > td {border-top: 0; color:black!important; } 
    #PrintPanel { font: 12px calibri;}  
    #PrintPanel  thead > tr > th{ font-weight: 600;line-height: normal; }
    .Tbl-Border  tbody > tr > td{padding: 5px }
    .s_formLabel {border: 1px solid #ccc;}
    .s_formLabel > tbody > tr{       
        border-bottom: 1px solid #ccc;
    }
    .s_formLabel > tbody > tr > td{
        padding: 5px;
    }
    #printContainer tr th{
        background: #D9D9D9 !important;
        padding: 8px 0 !important;
        text-align: center;
       }
       .Tbl-Border{
        border: 1px solid #bfbfbf;
    }
    .main-heading h1{font-size:16px !important;font-weight: 600;color:black!important;
    line-height: normal;}
    .SignatureTbl
    {
     border-top: 1px solid #ccc;
     padding: 5px 20px 0 20px;
     font-size: 15px;
    }
    .Tbl-Span
   {
    font-size: 12px;
   }
        .checked {
            color: #ffdb10 !important;
            border-color:#ffdb10 !important;
          }
          .unchecked{
            color: #D3D3DF !important;
            border-color:#ffdb10 !important;
          }
          .custom-th-le{
            background: #eeeeee !important;
            padding: 2px 10px !important;
            text-align: right;
            
        }  
        
        .job-dtl tbody>tr>td {
            padding: 2px;
            border-collapse: collapse !important;
        }
        .custom-th-ri{
            text-align: right;
        }
        .address-head{
            background: #eeeeee !important;
            padding: 3px 5px !important;                
        text-align: left;
        } 
        #printContainer thead {
            display: table-header-group;       
        }
    
        #printContainer tfoot {
            display: table-footer-group;
        }
    
        #printContainer table {
            border-collapse: collapse !important;
        }
    
        </style>
        `;
        // setTimeout(window.close, 5);
        popupWindow.document.write('<html><head><title>JobDetails</title>	' + headerScript + '</head><body id="wrapper" class="' + themeClass + '" onload="window.print();setTimeout(window.close, 5);">' + innerContents + '</body></html>');
        popupWindow.document.close();
    }
    attachmentsList: AttachmentsModel[];
    attachmentsFilter: AttachmentsListModel[];
    attachementchecklist: attachmentchecklist[];
    attachmentsqueue: attachmentchecklist[] = [];
    thumbListFilter: ThumbList[];
    thumbList: ThumbList[];
    Rating: number;
    feedback: string;
    feedbackby: string;
    isForms: boolean;
    isformAttachment: boolean;
    getAttachementsDetails(jobIds: number) {

        this.attachmentsList = [];
        this._technicianJobService.getAttachementsDetails(super.globalInfo().CompanyId, 0, jobIds)
            .subscribe(s => {

                this.attachmentsList = s;
                this.attachmentsFilter = [];

                for (let file of this.attachmentsList) {
                    file.Type = file.AttachementType;
                    file.CapturedDate = this.datetimeFormat(file.CapturedDate);
                    file.AttachementType = file.FileName.toLowerCase().split('.').pop();
                    file.DocType = false;
                    if (file.AttachementType == "png" || file.AttachementType == "jpg" || file.AttachementType == "jpeg" || file.AttachementType == "gif" || file.AttachementType == "dwg" || file.AttachementType == "") {
                        file.DocType = true;
                    }
                    file.CapturedDateFormat = file.CapturedDateFormat == "" ? "N/A" : this.datetimeFormat(file.CapturedDate);
                    file.LastUpdate = this.datetimeFormat(file.LastUpdate);
                    file.Type = file.Type == null ? 'Others' : file.Type;
                    // file.AttachementTypeId = file.AttachementTypeId == 0 ? 74 : file.AttachementTypeId;//others
                    this.attachmentsFilter.push(file);
                }
                this.attachmentsFilter.sort(function (a, b) {
                    var typeA = a.AttachementTypeId, typeB = b.AttachementTypeId
                    if (typeA < typeB) //sort string ascending
                        return -1
                    if (typeA > typeB)
                        return 1
                    return 0 //default return value (no sorting)
                });

                var TypeList = this.attachmentsFilter.map(t => t.Type);
                this.thumbList = [];
                TypeList.forEach(f => {
                    if (this.thumbList.filter(x => x.Type == f).length == 0) {
                        var list = new ThumbList();
                        list.Type = f;
                        list.AttachmentsGroupList = this.attachmentsFilter.filter(x => x.Type == f);
                        this.thumbList.push(list);
                    }
                });

                this.attachmentsFilter = this.attachmentsList;
                this.thumbListFilter = this.thumbList;
                if (this.thumbListFilter.length > 0) {
                    // this.IsJobImages = true;
                }
                this.JobPrintpreview.map(s => {
                    s.thumbListFilter = this.thumbListFilter;
                    s.pricingModelTable = this.pricingModelTable;
                })
                this.JobPrintpreviewWhole = this.JobPrintpreview;
                this.jobPrintPreWhole = new JobPrintPreWhole;
                this.jobPrintPreWhole.CustomerTechDetail = new CustomerDetails;
                this.jobPrintPreWhole.Equipment = new EquipmentDetails;
                this.jobPrintPreWhole.PartRequest = new PartRequestDetails;
                this.jobPrintPreWhole.specialInstruction = new specialInstructionDetails;
                this.jobPrintPreWhole.serviceNotes = new serviceNotesDetails;
                this.jobPrintPreWhole.technicalRemarks = new technicianRemarksDetails;
                this.jobPrintPreWhole.SlaHistoryEntity = new WoSLAHistoryDetails;
                this.jobPrintPreWhole.JobRMAPart = new JobRMAPartDetailsEntity;
                this.jobPrintPreWhole.JobShipping = new JobShippingDetailsEntity;
                this.jobPrintPreWhole.PCheckList = new PCheckListDetails;
                this.jobPrintPreWhole.thumbListFilter = new thumbListFilter;
                //this.jobPrintPreWhole.attachmentsqueue = new attachmentsqueueEntity;
                this.jobPrintPreWhole.attachmentsqueue = new PCheckListAttachmentDetails;
                this.jobPrintPreWhole.pricingModelTable = new PricingDetailsEntity;
                this.jobPrintPreWhole.travelConveyance = new TravelConveyanceEntity;
                this.jobPrintPreWhole.CustomerTechDetail.CustomerTechDetail = this.JobPrintpreviewWhole[0].CustomerTechDetail;

                this.jobPrintPreWholenew.push(this.jobPrintPreWhole.CustomerTechDetail);
                debugger;
                this.refEmailPrintJobSetting.forEach(f => {
                    if (f.SettingId == 1 && f.IsEnabled == 1) {
                        this.jobPrintPreWhole.SlaHistoryEntity.SortId = f.OrderId;
                        this.jobPrintPreWhole.SlaHistoryEntity.SettingId = f.SettingId;
                        this.jobPrintPreWhole.SlaHistoryEntity.SlaHistoryEntity = this.JobPrintpreview[0].SlaHistoryEntity.filter(x=>x.PriorityId!=null);
                        this.jobPrintPreWholenew.push(this.jobPrintPreWhole.SlaHistoryEntity);
                    }
                    if (f.SettingId == 2 && f.IsEnabled == 1) {
                        this.jobPrintPreWhole.Equipment.SortId = f.OrderId;
                        this.jobPrintPreWhole.Equipment.SettingId = f.SettingId;
                        this.jobPrintPreWhole.Equipment.Equipment = this.JobPrintpreview[0].Equipment;
                        this.jobPrintPreWholenew.push(this.jobPrintPreWhole.Equipment);
                    }
                    if (f.SettingId == 3 && f.IsEnabled == 1) {
                        this.jobPrintPreWhole.PartRequest.SortId = f.OrderId;
                        this.jobPrintPreWhole.PartRequest.SettingId = f.SettingId;
                        this.jobPrintPreWhole.PartRequest.PartRequest = this.JobPrintpreview[0].PartRequest;
                        this.jobPrintPreWholenew.push(this.jobPrintPreWhole.PartRequest);
                    }
                    if (f.SettingId == 4 && f.IsEnabled == 1) {
                        this.jobPrintPreWhole.JobShipping.SortId = f.OrderId;
                        this.jobPrintPreWhole.JobShipping.SettingId = f.SettingId;
                        this.jobPrintPreWhole.JobShipping.JobShipping = this.JobPrintpreview[0].JobRMAPartDetails;
                        this.jobPrintPreWholenew.push(this.jobPrintPreWhole.JobShipping);
                    }
                    if (f.SettingId == 5 && f.IsEnabled == 1) {
                        this.jobPrintPreWhole.JobRMAPart.SortId = f.OrderId;
                        this.jobPrintPreWhole.JobRMAPart.SettingId = f.SettingId;
                        this.jobPrintPreWhole.JobRMAPart.JobRMAPart = this.JobPrintpreview[0].JobRMAPartDetails;
                        this.jobPrintPreWholenew.push(this.jobPrintPreWhole.JobRMAPart);
                    }
                    if (f.SettingId == 6 && f.IsEnabled == 1) {
                        this.jobPrintPreWhole.pricingModelTable.SortId = f.OrderId;
                        this.jobPrintPreWhole.pricingModelTable.SettingId = f.SettingId;
                        this.jobPrintPreWhole.pricingModelTable.pricingModelTable = this.JobPrintpreview[0].pricingModelTable;
                        this.jobPrintPreWholenew.push(this.jobPrintPreWhole.pricingModelTable);
                    }
                    if (f.SettingId == 7 && f.IsEnabled == 1) {
                        this.jobPrintPreWhole.specialInstruction.SortId = f.OrderId;
                        this.jobPrintPreWhole.specialInstruction.SettingId = f.SettingId;
                        this.jobPrintPreWhole.specialInstruction.specialInstruction = this.JobPrintpreview[0].specialInstruction;
                        this.jobPrintPreWholenew.push(this.jobPrintPreWhole.specialInstruction);
                    }
                    if (f.SettingId == 8 && f.IsEnabled == 1) {
                        this.jobPrintPreWhole.serviceNotes.SortId = f.OrderId;
                        this.jobPrintPreWhole.serviceNotes.SettingId = f.SettingId;
                        this.jobPrintPreWhole.serviceNotes.serviceNotes = this.JobPrintpreview[0].serviceNotes;
                        this.jobPrintPreWholenew.push(this.jobPrintPreWhole.serviceNotes);
                    }
                    if (f.SettingId == 9 && f.IsEnabled == 1) {
                        this.isForms = true;
                        this.jobPrintPreWhole.PCheckList.SortId = f.OrderId;
                        this.jobPrintPreWhole.PCheckList.SettingId = f.SettingId;
                        this.jobPrintPreWhole.PCheckList.PCheckList = this.JobPrintpreview[0].PCheckList;
                        this.jobPrintPreWholenew.push(this.jobPrintPreWhole.PCheckList);
                    }
                    if (f.SettingId == 10 && f.IsEnabled == 1) {
                        this.isformAttachment = true;
                        this.jobPrintPreWhole.attachmentsqueue.SortId = f.OrderId;
                        this.jobPrintPreWhole.attachmentsqueue.SettingId = f.SettingId;
                        //this.jobPrintPreWhole.attachmentsqueue.PCheckList = this.JobPrintpreview[0].PCheckList;
                        this.jobPrintPreWhole.attachmentsqueue.PCheckListAttachment = this.JobPrintpreview[0].PCheckList;
                        this.jobPrintPreWholenew.push(this.jobPrintPreWhole.attachmentsqueue);
                    }
                    if (f.SettingId == 11 && f.IsEnabled == 1) {
                        this.jobPrintPreWhole.thumbListFilter.SortId = f.OrderId;
                        this.jobPrintPreWhole.thumbListFilter.SettingId = f.SettingId;
                        this.jobPrintPreWhole.thumbListFilter.thumbListFilter = this.JobPrintpreview[0].thumbListFilter;
                        this.jobPrintPreWholenew.push(this.jobPrintPreWhole.thumbListFilter);
                    }
                    if (f.SettingId == 18 && f.IsEnabled == 1) {
                        this.jobPrintPreWhole.technicalRemarks.SortId = f.OrderId;
                        this.jobPrintPreWhole.technicalRemarks.SettingId = f.SettingId;
                        this.jobPrintPreWhole.technicalRemarks.technicalRemarks = this.JobPrintpreview[0].technicalRemarks;
                        this.jobPrintPreWholenew.push(this.jobPrintPreWhole.technicalRemarks);
                    }
                    if (f.SettingId == 20 && f.IsEnabled == 1 && (this.actualWorkedTime !='' || this.TravelDuration != '')) {
                        this.jobPrintPreWhole.travelConveyance.SortId = f.OrderId;
                        this.jobPrintPreWhole.travelConveyance.SettingId = f.SettingId;
                        var travelConveyance = new TravelConveyance();
                        travelConveyance.AWorkduration = this.actualWorkedTime;
                        travelConveyance.ATravelDistance = this.DistanceKey;
                        travelConveyance.ATravelDuration  = this.TravelDuration;
                        this.jobPrintPreWhole.travelConveyance.TravelConveyance =[];
                        this.jobPrintPreWhole.travelConveyance.TravelConveyance.push(travelConveyance);
                        this.jobPrintPreWholenew.push(this.jobPrintPreWhole.travelConveyance);
                    }
                });
                debugger;
                this.jobPrintPreWholenew.sort(function (a, b) {
                    var nameA = a.SortId, nameB = b.SortId
                    if (nameA < nameB) //sort string ascending
                        return -1
                    if (nameA > nameB)
                        return 1
                    return 0 //default return value (no sorting)
                });


            })
    }
    ratingLimit: number[] = [];
    nonratinglimit: number[] = [];
    unrating: number;
    GetByCustomerFeedBack(jobIds: number) {
        this._technicianJobService.GetByCustomerFeedBack(jobIds, super.globalInfo().CompanyId)
            .subscribe(s => {
                debugger;
                if (s.length > 0) {
                    this.Rating = s[0].Rating;
                    this.feedback = s[0].Feedback;
                    this.feedbackby = s[0].FeedbackBy;
                    for (var i = 0; i < this.Rating; i++) {
                        this.ratingLimit.push(1);
                    }
                    this.unrating = 5 - this.Rating;
                    if (this.unrating != 0) {
                        for (var i = 0; i < this.unrating; i++) {
                            this.nonratinglimit.push(1);
                        }
                    }
                }
            });

    }
    dayhourFormat(day: number, hour: number, min: number): any {
        var data = "";
        if (day !== null && day > 0) {
            let str = 'day';
            if (day > 1)
                str = 'days'

            data += day + ' ' + str + ' ';
        }
        if (hour !== null && hour > 0) {
            let str = 'hr';
            if (hour > 1)
                str = 'hrs'
            data += hour + ' ' + str + ' ';
        }
        if (min !== null && min > 0) {
            let str = 'min';
            if (hour > 1)
                str = 'mins'
            data += min + ' ' + str + ' ';
        }
        return data;
    }
    mintohours(min: number): any {
        var data = "";
        if (min !== null && min > 0) {
            let str = 'min';
            if (min > 1)
                str = 'mins'
            data += min + ' ' + str + ' ';
        }
        return data;
    }

}